import { Action, createReducer, on } from '@ngrx/store';

import {
  fetchFiltersAction,
  fetchFiltersSuccessAction,
  searchFlightsForMobileErrorAction,
  noResultsSearchFlightsAction,
  fetchAirGroupResultsSuccessAction,
  searchFlightsForDesktopErrorAction,
  searchFlightsAction,
  fetchFiltersBySectorAction,
  setFlightResultsLoadingAction,
} from '@flight-results/store/actions/flights-results.actions';

export const initialState = false;

const featureReducer = createReducer(
  initialState,
  on(
    searchFlightsAction,
    fetchFiltersAction,
    fetchFiltersBySectorAction,
    () => true
  ),
  on(
    fetchFiltersSuccessAction,
    noResultsSearchFlightsAction,
    searchFlightsForMobileErrorAction,
    searchFlightsForDesktopErrorAction,
    fetchAirGroupResultsSuccessAction,
    () => initialState
  ),
  on(setFlightResultsLoadingAction, (state, { payload }) => (payload))
);

export const isLoadingFiltersReducer = (state: boolean, action: Action): boolean => {
  return featureReducer(state, action);
};
